import { Navigate, Outlet, useLocation } from "react-router";
import { ROUTES, STORAGE_IS_INITIAL_SURVEY } from "utils/constants";
import { getFromLocalStorage, hasLoginTokens } from "utils/Utils";

const PrivateRoute = () => {
  const location = useLocation();

  // Check if user has login tokens
  if (!hasLoginTokens()) {
    return <Navigate to={ROUTES.LOGIN} />;
  }

  // Check if initial survey is completed
  const initialSurveyCompleted =
    getFromLocalStorage(STORAGE_IS_INITIAL_SURVEY) === "true";

  // If initial survey is not completed and user is trying to access any route other than welcome
  // redirect them to the welcome page
  if (
    !initialSurveyCompleted &&
    !location.pathname.startsWith(ROUTES.WELCOME)
  ) {
    return <Navigate to={ROUTES.WELCOME} replace />;
  }

  return <Outlet />;
};

export default PrivateRoute;
